<template>
  <div class="d-flex">
    <!-- Mobile back button -->
    <button class="navbar-button d-lg-none" @click="goBack" type="button" v-if="showBack">
      <icon icon="chevron-left" />
    </button>
    <!-- Responsive progress bar -->
    <progress-bar
      class="flex-grow-1"
      ref="navbarComponent"
      :steps="protectWizardSteps"
      @clickStep="goTo"
      :disabled="!canNavigate"
      :currentStep="currentStep"
      :currentStepChecked="currentStepChecked"
      />

    <!-- Cost estimate -->
    <div class="navbar-text" v-if="estimated_quote_price">
      <!-- Final Cost -->
      <span v-if="estimated_quote_price.total_price">{{estimated_quote_price.total_price | currency}}</span>
      <!-- Estimate with the hard coded currency TODO dynamic currency-->
      <span v-else-if="estimated_quote_price.min_price && estimated_quote_price.max_price && estimated_quote_price.min_price == estimated_quote_price.max_price">
        £{{estimated_quote_price.min_price}}</span>
      <span v-else-if="estimated_quote_price.min_price && estimated_quote_price.max_price">
        £{{Math.floor(estimated_quote_price.min_price)}} - {{Math.ceil(estimated_quote_price.max_price)}}</span>
    </div>
  </div>
</template>
<script>
import ProgressBar from '@/components/ProgressBar.vue'
export default {
  name: 'ProtectWizardProgress',
  components: { ProgressBar },
  data: function () {
    return {
      protectWizardSteps: [
        { name: 'amount', label: 'Amount' },
        { name: 'debtor', label: 'Customer' },
        { name: 'dates', label: 'Term' },
        // { name: 'product', label: 'Product' },
        { name: 'creditor', label: 'Creditor' }
      ]
    }
  },
  computed: {
    estimated_quote_price: function () {
      return this.$store.state.protectWizard.estimated_quote_price
    },
    canNavigate: function () {
      return this.$store.state.protectWizard.alive
    },
    currentStepChecked: function () {
      return this.$store.state.protectWizard.check
    },
    currentStep: function () {
      return this.$store.state.protectWizard.step
    },
    showBack: function () {
      return this.currentStepChecked || this.currentStep > 0
    }
  },
  methods: {
    goBack: function () {
      if (!this.canNavigate) return
      if (this.$route.name !== 'protect') {
        this.$router.replace({ name: 'protect' })
      }
      if (this.currentStepChecked) {
        // If on "check" route, stay on same page, otherwise, go back a page
        this.$store.commit('protectWizard/CHECK', false)
      } else if (this.currentStep > 0) {
        // Only go back if not on page 1
        this.$store.commit('protectWizard/STEP_UPDATE', this.currentStep - 1)
      }
    },
    goTo: function (index) {
      if (!this.canNavigate) return
      this.$store.commit('protectWizard/CHECK', false)
      this.$store.commit('protectWizard/STEP_UPDATE', index)
    }
  },
  watch: {
    showBack: function (value) {
      this.$emit('showBack', value)
    }
  }
}
</script>
